import dayjs from "dayjs"
const BASE_URL = process.env.VUE_APP_BASE_URL
import default_img from '@/assets/images/shop/apple-smart-watch.jpg'
import { ProductsStatus } from "../constants/products"

export const formattedPrices = (data) => {
  return data.toLocaleString('es-PE', {
    style: 'currency',
    currency: 'PEN',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })
}

export const formattedDateText = value => {
  if (!value) return value

  return dayjs(value).format('LL')
}

export const formattedDataProductsTrending = data => {
  if(!data.length) return []

  return data.map(d => {
    const imageUrl = d?.image ? `${BASE_URL}/storage/uploads/items/${d.image}` : null
    const defaultImage = default_img

    // Crear un objeto de imagen para verificar si la imagen se carga correctamente
    const image = new Image()
    image.src = imageUrl

    // Retornar los datos formateados con la verificación de la imagen
    return {
      image: imageUrl, // Asignamos inicialmente la URL original
      status: ProductsStatus[d.status]?.value,
      percentage: Number(d?.percentage_isc),
      name: d?.description || null,
      price: Number(d?.sale_unit_price) || 0.00,
      price2: Number(d?.suggested_price) || 0.00,
      sku: d?.barcode || 'not',
      imageHandled: new Promise((resolve) => {
        // Si la imagen se carga bien, la dejamos; si no, usamos la imagen por defecto
        image.onload = () => resolve(imageUrl)
        image.onerror = () => resolve(defaultImage)
      })
    }
  })
}